export default __webpack_public_path__ + "static/media/AIR POLUITION.82cabca4.jpg";